import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AppPenetrationPage, Navigation } from '../../models';
import { getMobileOS } from '../../utils/mobileOS';
import OpenAppDialog from './OpenAppDialog';

const mobileOS = getMobileOS();

/**
 * Exact pathname → page. The selling area is not here: it renders its own
 * dialog from the locker configs. Adding a page needs the same value on the API.
 */
const PAGE_BY_PATH: Record<string, AppPenetrationPage> = {
	'/': 'HOME',
	'/wallet': 'WALLET',
	'/lista-ordini': 'ORDER_LIST',
};

/**
 * Mounted once in App, outside the routes, so internal SPA redirects can never
 * stack two dialogs. Every route mount refetches `b2c/navigation`: each fresh
 * navigation (re)opens the dialog for the current page, so closing it hides it
 * only until the next page — and a reload shows it again.
 */
export default function GlobalOpenAppDialog({ navigation }: { navigation: Navigation | null }) {
	const location = useLocation();
	// The pathname the dialog is open for; null when closed.
	const [openFor, setOpenFor] = useState<string | null>(null);

	useEffect(() => {
		if (!navigation) {
			return;
		}
		const page = PAGE_BY_PATH[window.location.pathname];
		setOpenFor(page && navigation.appPenetrationActions?.[page] ? window.location.pathname : null);
		// Only a fresh navigation payload opens it: re-renders on the same page must not.
	}, [navigation]);

	const page = PAGE_BY_PATH[location.pathname];
	const action = page ? navigation?.appPenetrationActions?.[page] : null;

	if (!mobileOS || !page || !action) {
		return null;
	}

	return (
		<OpenAppDialog
			open={openFor === location.pathname}
			action={action}
			page={page}
			onClose={() => setOpenFor(null)}
		/>
	);
}
